// extracted by mini-css-extract-plugin
export default {"break-point-md":"40rem","break-point-lg":"60rem","team":"Team_team__6so6w","team__title":"Team_team__title__THmCT","team__list":"Team_team__list__puDDi"};